module.exports = __webpack_public_path__ + "img/02d.52bad4ac.svg";